import { Form, BaseModel, Entry, EntryTypes, Resource } from '@ngx-resource-toolkit/core';
import { environment } from '../../../environments/environment';
import { LeaResource } from '../../shared/resource/lea.resource';
import { base64StringToBlob } from 'blob-util';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/fichier',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'table': {},
    'create': {},
})
export class FileModel extends BaseModel {

    _explicitType = 'Fichier';
    @Entry({
        base: {
            hidden: true,
            type: EntryTypes.STATIC,
        },
        'table': {},
        'create': {},
    })
	id: number;

    @Entry({
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            label: 'Nom'
        },
        'create': {}
    })
    nom: string;

    @Entry({
        base: {
            hidden: true,
        },
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            label: 'Desxription'
        },
        'create': {}
    })
    description: string;

    @Entry({
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            label: 'Poids'
        },
        'create': {}
    })
    taille: number;

    @Entry({
        'table': {
            type: EntryTypes.TABLE,
            flexGrow: 1,
            label: 'Type'
        },
        'create': {}
    })
    type: string;

    @Entry({
        base: {
            hidden: true,
        },
        'create': {},
        'table': {},
    })
    data: any;
    @Entry({
        base: {
            hidden: true,
        },
        'create': {},
        'table': {},
    })
    data64: any;

    file: File;

    blobUrl: string;

    constructor(file: any = {}, data: any = '') {
        super();
        this.description = file.description;
        this.id = file.id;
        this.file = file;
        this.nom = file.name || file.nom;
        this.taille = file.size || file.taille;
        this.type = file.type;
        this.data = data;
        this.blobUrl = data ? this.toBlobUrl() : null;
    }

    toBlobUrl() {
        const data = this.data.split(',')[1];
        const type = this.data.split(',')[0].split(':')[1].split(';')[0];
        const blob = base64StringToBlob(data, type);
        return URL.createObjectURL(blob);
    }

}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/courriel/models/file.model.ts